/**
 * Quick-link descriptor for the organization hub at `/company`.
 */
export type CompanyHubLink = {
  detailKey: string;
  icon: string;
  id: string;
  route: string[];
  testId: string;
  titleKey: string;
};

/** Session predicates used to build persona-filtered hub links. */
export type CompanyHubLinkSession = {
  isAdmin: boolean;
  isSupplier: boolean;
  isZone: boolean;
};

/**
 * Builds persona-filtered quick links for the organization hub.
 *
 * Emits only destinations that have no dedicated snapshot on the hub:
 * - **Factories** — `admin` only (suppliers use the factory snapshot section).
 * - **Industrial areas** — `zone` and `admin`.
 *
 * Team and Edit are intentionally omitted — those actions live in the page hero.
 */
export function buildCompanyHubLinks(
  session: CompanyHubLinkSession
): CompanyHubLink[] {
  const { isAdmin, isSupplier, isZone } = session;
  const links: CompanyHubLink[] = [];

  if (isAdmin && !isSupplier) {
    links.push({
      detailKey: 'hub.links.factories.detail',
      icon: 'warehouse',
      id: 'factories',
      route: ['/factories'],
      testId: 'company-hub-link-factories',
      titleKey: 'hub.links.factories.title',
    });
  }

  if (isZone || isAdmin) {
    links.push({
      detailKey: 'hub.links.industrialAreas.detail',
      icon: 'map',
      id: 'industrialAreas',
      route: ['/industrial-area'],
      testId: 'company-hub-link-industrial-areas',
      titleKey: 'hub.links.industrialAreas.title',
    });
  }

  return links;
}
